import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import Contact from './components/Contact';
import Contactowner from './components/Contactowner';
import About from './components/About';
import Privacy from './components/Privacy';
import History from './components/History';
import Download from './components/Download';
import Test from './components/Test';


const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/scanqr" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/contactowner" element={<Contactowner />} />
        <Route path="/terms&conditions" element={<About/>} />
        <Route path="/privacy" element={<Privacy/>} />
        <Route path="/history" element={<History/>} />
        <Route path="/" element={<Download/>} />
        <Route path="/test" element={<Test/>} />
       

      </Routes>
    </Router>
  );
};

export default App;
